module.exports = __webpack_public_path__ + "static/Kaffee-(Cappuccino)-47542163462669b0cab74c331914f7ad.png";